const fr = {
  // Navigation
  navigation: {
    tracking: "Suivi",
    search: "Rechercher",
    login: "monMSC",
    language: "Langue"
  },
  
  // Menu items
  menu: {
    solutions: "Solutions",
    industries: "Industries",
    ebusiness: "eCommerce",
    sustainability: "Durabilité",
    aboutUs: "À Propos",
    schedules: "Horaires"
  },
  
  // Hero section
  hero: {
    leaderIn: "LEADER EN",
    shippingLogistics: "EXPÉDITION & LOGISTIQUE",
    trackingTab: "SUIVI",
    schedulesTab: "HORAIRES",
    contactsTab: "CONTACTS",
    containerBol: "Numéro de conteneur / connaissement",
    bookingNumber: "Numéro de réservation",
    searchPlaceholder: "Rechercher nos services et solutions...",
    searchButton: "Rechercher"
  },
  
  // Example component
  example: {
    title: "Utilisation des traductions entre les composants",
    text: "Ce texte provient du système de traduction. Chaque composant peut utiliser le hook de traduction pour afficher du contenu dans la langue sélectionnée."
  },
  
  // Services Component
  services: {
    sectionTitle: "Nos Services",
    sectionDescription: "Ocean Crown propose des services complets de transport et de logistique conçus pour optimiser votre chaîne d'approvisionnement et améliorer les performances de votre entreprise.",
    learnMore: "En Savoir Plus",
    contactUs: "Demander une Solution Personnalisée",
    
    ocean: {
      title: "Fret Maritime",
      description: "Services de fret maritime fiables reliant les principaux ports du monde avec des départs et des arrivées programmés.",
      feature1: "Expédition FCL (conteneur complet)",
      feature2: "Options LCL (conteneur partiel)",
      feature3: "Équipement spécialisé pour cargo surdimensionné"
    },
    
    land: {
      title: "Transport Terrestre",
      description: "Solutions complètes de transport routier et ferroviaire pour la distribution régionale et internationale.",
      feature1: "Services de camion FTL et LTL",
      feature2: "Transport ferroviaire intermodal",
      feature3: "Solutions porte-à-porte"
    },
    
    warehousing: {
      title: "Entreposage",
      description: "Installations d'entreposage stratégiques dans des emplacements clés offrant des services de stockage, de distribution et à valeur ajoutée.",
      feature1: "Options de stockage à court et long terme",
      feature2: "Gestion des inventaires",
      feature3: "Traitement des commandes"
    },
    
    global: {
      title: "Logistique Globale",
      description: "Solutions de chaîne d'approvisionnement de bout en bout adaptées aux besoins de votre entreprise et aux exigences mondiales.",
      feature1: "Conseil en chaîne d'approvisionnement",
      feature2: "Expertise en expédition internationale",
      feature3: "Transport multimodal"
    },
    
    customs: {
      title: "Courtage en Douane",
      description: "Services de dédouanement rationalisés pour naviguer dans les réglementations complexes du commerce international.",
      feature1: "Documentation d'importation/exportation",
      feature2: "Conseil en conformité douanière",
      feature3: "Gestion des droits et taxes"
    },
    
    documentation: {
      title: "Services de Documentation",
      description: "Gestion experte de toute la documentation d'expédition pour assurer la conformité et des opérations fluides.",
      feature1: "Préparation des connaissements",
      feature2: "Gestion des certificats d'origine",
      feature3: "Documentation électronique"
    },
    
    featured: {
      title: "Solutions Intégrées Ocean Crown",
      description: "Notre plateforme logistique intégrée combine plusieurs services en une solution de chaîne d'approvisionnement transparente, offrant visibilité, efficacité et fiabilité.",
      item1: {
        title: "Visibilité de la Chaîne d'Approvisionnement",
        description: "Suivi et surveillance en temps réel de vos expéditions avec des mises à jour détaillées sur le statut et des alertes d'exception."
      },
      item2: {
        title: "Analytique de Performance",
        description: "Rapports et analyses complets pour identifier les opportunités d'optimisation dans votre chaîne d'approvisionnement."
      }
    }
  },
  
  // Stats Component
  stats: {
    title: "Portée Mondiale, Expertise Locale",
    description: "Avec un réseau mondial robuste et une connaissance locale approfondie, nous connectons les entreprises à travers les continents.",
    years: "Années d'Expérience",
    countries: "Pays Desservis",
    clients: "Clients Actifs",
    shipments: "Expéditions Annuelles"
  },
  
  // Industries Component
  industries: {
    title: "Industries Que Nous Servons",
    description: "Solutions spécialisées pour divers secteurs d'activité, chacun avec des exigences uniques en matière de chaîne d'approvisionnement.",
    automotive: {
      title: "Automobile",
      description: "Logistique juste-à-temps pour les fabricants et fournisseurs automobiles."
    },
    retail: {
      title: "Commerce & Consommation",
      description: "Solutions de fulfillment omnicanal pour les détaillants et les entreprises de biens de consommation."
    },
    pharma: {
      title: "Santé & Pharmacie",
      description: "Logistique à température contrôlée et conforme pour l'industrie de la santé."
    },
    manufacturing: {
      title: "Fabrication",
      description: "Logistique rationalisée pour les chaînes d'approvisionnement et les lignes de production."
    },
    energy: {
      title: "Énergie & Ressources",
      description: "Services spécialisés pour le secteur de l'énergie et les industries des ressources."
    },
    tech: {
      title: "Technologie",
      description: "Logistique rapide et sécurisée pour les produits et composants technologiques de grande valeur."
    }
  },
  
  // Footer
  footer: {
    about: {
      title: "À propos d'Ocean Crown",
      description: "Un leader mondial des services d'expédition et de logistique avec plus de 30 ans d'excellence dans le commerce international."
    },
    quickLinks: "Liens Rapides",
    contactUs: "Contactez-Nous",
    subscribe: {
      title: "Abonnez-vous à Notre Newsletter",
      placeholder: "Votre adresse email",
      button: "S'abonner",
      description: "Restez informé des dernières nouvelles du secteur et des mises à jour de l'entreprise."
    },
    copyright: "© 2023 Ocean Crown. Tous droits réservés.",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions d'Utilisation"
  }
};

export default fr; 